import React from 'react';
import { Loading as LoadingSpinner } from '@defa/defa-component-library';
import { Root } from './loading.styles';
import i18n from '../../i18n';

export const Loading: React.FunctionComponent = () => (
    <Root aria-label={i18n.t('Dashboard.Loading')}>
        <LoadingSpinner />
    </Root>
);
